import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./styles.css";
import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
export * from "./app-config";

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
